import { VALIDATOR_PATTERNS } from "src/app/helper/class/app-constant";
import { formBuilderData } from "src/app/helper/interface/response";

export const PROMOTIONAL_FORM: formBuilderData[] = [
    {
      colName: 'promotional_id',
      title: 'Promo ID',
      readonly: true,
      hidden: true
    },
    {
      colName: 'promotionalName',
      title: 'Promotional Name',
      validator: [{ name: 'required' }]
    },
    {
      colName: 'email_id',
      validator: [{ name: 'required' },
      { name: 'pattern', funValue: VALIDATOR_PATTERNS.EMAIL }]
    },
    {
      colName: 'phone',
      title: 'Mobile',
      validator: [{ name: 'required' },
      { name: 'pattern', funValue: VALIDATOR_PATTERNS.MOBILE }]
    },
    {
      colName: 'whatsapp_number',
      title: 'WhatsApp Number',
      visible: false,
      validator: [{ name: 'pattern', funValue: VALIDATOR_PATTERNS.MOBILE }]
    },

    {
      colName: 'contact_name',
      validator: [{ name: 'required', error: 'Contact should not be blank' },
      { name: 'pattern', funValue: VALIDATOR_PATTERNS.TEXT }]
    },
    {
      colName: 'street',
      visible: false,
      validator: [{ name: 'required' },
      { name: 'pattern', funValue: VALIDATOR_PATTERNS.TEXT }]
    },
    {
      colName: 'sub_district_name',
      visible: false,
      validator: [{ name: 'pattern', funValue: VALIDATOR_PATTERNS.TEXT }]
    },
    {
      colName: 'district_name',
      visible: false,
      validator: [{ name: 'pattern', funValue: VALIDATOR_PATTERNS.TEXT }]
    },
    {
      colName: 'city_name',
      visible: false,
      validator: [{ name: 'pattern', funValue: VALIDATOR_PATTERNS.TEXT }]
    },
    {
      colName: 'state_name',
      validator: [{ name: 'required' },
      { name: 'pattern', funValue: VALIDATOR_PATTERNS.TEXT }]
    },
    {
      colName: 'country_name',
      validator: [{ name: 'required' },
      { name: 'pattern', funValue: VALIDATOR_PATTERNS.TEXT }]
    },
    {
      colName: 'pincode',
      visible: false,
      validator: [
        { name: 'pattern', funValue: VALIDATOR_PATTERNS.NUMBER }]
    },
    {
      colName: 'in_chargeName',
      visible: true,
      hidden: true,
      title: 'In charge',
    },
    {
      colName: 'in_charge_mobile_no',
      visible: true,
      hidden: true,
    },
    {
      colName: 'report_to_promotional_id',
      visible: true,
      hidden: true,
      title: 'Report To',
    }
  ];